module.exports = __webpack_public_path__ + "u1.no2.cb3686eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u1.no2.jpg
// module id = hoiT
// module chunks = 0